import { Attempt } from '@/common/types/session';
import { formatTimeTaken } from '@/common/utils/datetime';
import { getCorrectSegmentsForSentenceBuilder } from '@/common/utils/getCorrectSegments';
import { TableCell, TableHead, TableRow } from '@shadcn/components/table';
import { capitalize } from 'lodash';
import GenericAttemptTable, {
  getControlIcon,
  getHasControl,
  renderStudentAnswer,
} from './GenericAttemptTable';

interface SentenceBuilderAttemptTableProps {
  attempts: Attempt[];
}
export default function SentenceBuilderAttemptTable({
  attempts,
}: SentenceBuilderAttemptTableProps) {
  const hasControl = getHasControl(attempts);

  const applySentenceStyle = (sentence: string) => {
    return capitalize(sentence) + '.';
  };

  const getCorrectSegments = (itemId: string) => {
    return applySentenceStyle(
      getCorrectSegmentsForSentenceBuilder(itemId)?.join(' ') ?? '',
    ).split(' ');
  };

  return (
    <GenericAttemptTable
      renderHeader={() => (
        <TableRow className="hover:bg-white">
          <TableHead>Attempt</TableHead>
          <TableHead>Served Sentence</TableHead>
          <TableHead>Student Attempt</TableHead>
          <TableHead>Time Taken</TableHead>
          {hasControl && <TableHead>Control</TableHead>}
        </TableRow>
      )}
      renderData={() =>
        attempts.map((attempt: any, index: number) => (
          <TableRow key={index} className="hover:bg-white">
            <TableCell>{index + 1}</TableCell>
            <TableCell>{applySentenceStyle(attempt.correctAnswer)}</TableCell>
            <TableCell>
              {renderStudentAnswer({
                attempt,
                getCorrectSegments,
                isCorrect:
                  attempt.studentAnswer ===
                  applySentenceStyle(attempt.correctAnswer),
              })}
            </TableCell>
            <TableCell>
              {formatTimeTaken(attempt.startedAt, attempt.endedAt)}
            </TableCell>
            {hasControl && (
              <TableCell className="pl-6">
                {getControlIcon(attempt.control!)}
              </TableCell>
            )}
          </TableRow>
        ))
      }
      isEmpty={attempts.length === 0}
    />
  );
}
